<template>
  <div class="unbalanceCom">
    <div class="wrap ashComWrap" v-for="(v, i) in list" :key="i">
      <div class="comTitle">
        <h4>{{ v.name }}</h4>
      </div>
      <div class="comContentBox">
        <div class="item">
          <PublicEcharts
            :id="'unbalanceItem1' + i"
            :chartsData="v.chartsData"
            :type="'lightLine'"
          />
        </div>
        <div class="item">
          <PublicEcharts
            :id="'unbalanceItem2' + i"
            :chartsData="v.chartsData1"
            :type="'lightLine'"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import PublicEcharts from "@/components/PublicEcharts";
import { handleNumDecimal } from "@/assets/js/utils";
export default {
  props: {
    parameterItem: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    PublicEcharts,
  },
  data() {
    return {
      list: [],
    };
  },
  watch: {
    parameterItem: {
      handler() {
        if (this.parameterItem.id) {
          this.$store.commit("SET_LOADING", true);
          this.list = Array.from(this.parameterItem.harmonicParameter).map(
            (v) => ({
              name: v.name,
              key: v.key,
              chartsData: { unit: "", xData: [], dataArr: [] },
              chartsData1: { unit: "", xData: [], dataArr: [] },
            })
          );
          this.handlerData();
        }
      },
      deep: true,
    },
  },
  methods: {
    handlerData() {
      this.list.map((v) => {
        Promise.all([
          this.getChartsFun({ key: v.key, forMore: true }),
          this.getChartsFun({ key: v.key, forMore: false, keyName: v.name }),
        ]).then((res) => {
          v.chartsData = res[0];
          v.chartsData1 = res[1];
        });
      });
      this.$store.commit("SET_LOADING", false);
    },
    async getChartsFun(defObj) {
      let charts = { unit: "", xData: [], dataArr: [] };
      let obj = {
        assetId: this.parameterItem.id,
        date: this.parameterItem.timeValue,
        dateType: "DAY",
      };
      let res = await api.PDSGetHarmonicCharts(Object.assign({}, defObj, obj));
      if (res && res.data.code == 200) {
        if (res.data.data.length) {
          let arr = res.data.data;
          charts.unit = arr[0]?.unit ?? "";
          let newArr = [];
          arr.map((v) => {
            charts.xData.push(this.$moment(v.ts).format("HH:mm"));
            newArr.push(v.tsKVList);
          });
          for (let i = 0; i < newArr[0].length; i++) {
            charts.dataArr.push({ name: "", data: [] });
            newArr.forEach((item, index) => {
              charts.dataArr[i].name = item[i].name;
              charts.dataArr[i].data.push(
                item[i].value ? handleNumDecimal(item[i].value) : ""
              );
            });
          }
        }
      }

      return charts;
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.unbalanceCom {
  width: 100%;
  height: 98%;
  margin: 1% 0;
  @include setFlexBetween;
  .wrap {
    width: $halfWidth;
    height: 100%;
    box-shadow: 0 0.010417rem 0.0625rem 0 rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    .item {
      width: 100%;
      height: 50%;
    }
  }
}
</style>
